import { createMessageStore } from "./MessageStore";

export const textMessageStore = createMessageStore();
